import * as types from '../actions/actionTypes';
import initialState from './initialState';
        
export default function resultadoexamenReducer(state= initialState.resultadoexamen, action){
    let newState;
    
	switch(action.type){
         case types.LOAD_RESULTADOEXAMEN_LIST_SUCCESS:		
            /*
            action.resultadoexamen.filtroActivo=state.filtroActivo;
            action.resultadoexamen.filtroActual=state.filtroActual;
            action.resultadoexamen.showActivos=state.showActivos;
			 action.resultadoexamen.paginaActual=action.resultadoexamen.pageable.pageNumber;
			 action.resultadoexamen.registrosPorPagina=action.resultadoexamen.size;
            */
            return action.resultadoexamen;

        case types.BORRAR_RESULTADOEXAMEN_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(resultadoexamen => resultadoexamen.id !== action.resultadoexamen.id)];          
			return newState;    
            
        case types.ACTIVAR_RESULTADOEXAMEN_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(resultadoexamen => resultadoexamen.id !== action.resultadoexamen.id)];          
			 return newState;
            
        case types.SET_FILTRO_RESULTADOEXAMEN:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}